var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'inline': _vm.inline}},[_c('x-label',{attrs:{"color":"primary","title":_vm.title}},[_c('i',{staticClass:"fa fa-commenting-o"}),_vm._v(" SMS blast\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }